import { useQuery } from '@tanstack/react-query';
import { SalesVenueApiClient } from 'api';

export const useSalesVenues = () => {
  return useQuery({
    queryKey: ['salesVenues'],
    queryFn: () => SalesVenueApiClient.getAllSalesVenues(),
  });
}; 